<template>
  <div class="routing-detail-track-trace">
    <h5  class="pt-5 title">Routing Details</h5>

    <b-card class="b-card-bg">
      <div
        class="card-text px-1"
        :class="{ 'card-white': !isPublic }"
      >
        <b-row class="hr-bottom">
          <b-col cols="12" md="3"
            ><span class="text-bold-800">Origin Port</span>
            <span class="hr">{{ shipment_detail.pol_port }}</span>
          </b-col>
          <b-col cols="12" md="3">
            <span class="text-bold-800">Transit Port</span>
            <span class="hr">{{ shipment_detail.transit_port }}</span></b-col
          >
          <b-col cols="12" md="3">
            <span class="text-bold-800">Delivery Port</span>
            <span class="hr">{{ shipment_detail.pod_port }}</span></b-col
          >
          <b-col cols="12" md="3">
            <span class="text-bold-800">Vessel/Voyage</span>
            <span class="hr">{{ shipment_detail.vessel }}</span></b-col
          >
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12" md="3"
            ><span class="text-bold-800">ETD</span>
            <span class="hr">{{ shipment_detail.etd }}</span>
          </b-col>
          <b-col cols="12" md="3">
            <span class="text-bold-800">ETA</span>
            <span class="hr">{{ shipment_detail.eta }}</span></b-col
          >
          <b-col cols="12" md="3">
            <span class="text-bold-800">Quotation No.</span>
            <span class="hr">
              {{
                request_quotation.quotation
                  ? request_quotation.quotation.toString().startsWith("WR1")
                    ? request_quotation.quotation
                    : ""
                  : ""
              }}</span
            ></b-col
          >
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    request_quotation: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shipment_detail: {
        pol_port: "",
        transit_port: "",
        pod_port: "",
        vessel: "",
        etd: "",
        eta: "",
        quotation: "",
      },
    };
  },
  computed: {
    ...mapState("masterDataNoLogin", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "locations",
    ]),
  },
  watch: {
    value(n, o) {
      this.shipment_detail.pol_port =
        this.ports.find((e) => e.id == this.value?.pol_port)?.name || "";
      this.shipment_detail.transit_port =
        this.ports.find((e) => e.id == this.value?.transit_port)?.name || "";
      this.shipment_detail.pod_port =
        this.ports.find((e) => e.id == this.value?.pod_port)?.name || "";
      this.shipment_detail.vessel = this.value?.vessel || "";
      this.shipment_detail.etd = this.value?.etd || "";
      this.shipment_detail.eta = this.value?.eta || "";
      this.shipment_detail.quotation = this.value?.quotation || "";
    },
  },
  methods: {},
  mounted() {
    if(this.value){
      this.shipment_detail.pol_port =
        this.ports.find((e) => e.id == this.value?.pol_port)?.name || "";
      this.shipment_detail.transit_port =
        this.ports.find((e) => e.id == this.value?.transit_port)?.name || "";
      this.shipment_detail.pod_port =
        this.ports.find((e) => e.id == this.value?.pod_port)?.name || "";
      this.shipment_detail.vessel = this.value?.vessel || "";
      this.shipment_detail.etd = this.value?.etd || "";
      this.shipment_detail.eta = this.value?.eta || "";
      this.shipment_detail.quotation = this.value?.quotation || "";
    }


  },
};
</script>

<style lang="scss">
.routing-detail-track-trace {
  .text-bold-800 {
    font-weight: 800;
  }
  .card-text {
    padding: 20px 10px;
    margin: 10px 0px;
  }

  .hr {
    border-left: 2px solid #fff;
    margin-left: 10px;
    padding-left: 10px;
  }

  .hr-bottom {
    padding-bottom: 20px;
    border-bottom: 2px solid #e1f1ee;
  }

  .card-white {
    .hr {
      border-left: 2px solid #e1f1ee;
    }
  }

  .justify-content-space-evenly {
    justify-content: space-evenly;
  }
  .text-end {
    text-align: end;
  }
}
</style>
